var _path, _polygon, _path2, _polygon2, _path3, _rect, _path4, _rect2, _path5, _rect3, _rect4, _polygon3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMill(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-3ebc3e55-8cf9-462d-bcc4-2fd5541a1a6a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m40.47,13.64h-3.68c-4.61,0-8.35,3.75-8.35,8.35v5.84l12.44,2.2c.31-3.12,2.41-5.72,5.26-6.75v-2.37c0-.85.69-1.54,1.54-1.54h.72c-1.1-3.33-4.24-5.73-7.93-5.73Z",
    fill: "none"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "18.48 14.83 11.26 14.83 10.83 24.71 18.98 26.16 18.48 14.83",
    fill: "#15a9af"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m28.44,22c0-4.61,3.75-8.35,8.35-8.35h3.68c3.69,0,6.82,2.41,7.93,5.73h2.24c-1.17-4.53-5.28-7.89-10.17-7.89h-3.68c-5.8,0-10.51,4.71-10.51,10.51v5.46l2.16.38v-5.84Z",
    fill: "#15a9af"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "18.2 8.67 11.54 8.67 11.33 13.46 18.42 13.46 18.2 8.67",
    fill: "#15a9af"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m48.86,22.8h1.85c.59,0,1.17.07,1.72.19v-2.08c0-.3-.24-.54-.54-.54h-4.22c-.3,0-.54.24-.54.54v2.08c.56-.12,1.13-.19,1.72-.19Z",
    fill: "#075255"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 41.84,
    y: 38.9,
    width: 15.9,
    height: 12.33,
    fill: "#075255"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m57.74,30.83c0-3.87-3.15-7.02-7.02-7.02h-1.85c-3.87,0-7.02,3.15-7.02,7.02v3.08h15.9v-3.08Z",
    fill: "#075255"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 41.84,
    y: 34.91,
    width: 15.9,
    height: 3,
    fill: "#075255"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m5.76,24.83v26.4h35.08v-20.18L5.76,24.83Zm5.69,19.83v-9.55h6.85v9.55h-6.85Zm22.59,0h-6.85v-9.55h6.85v9.55Z",
    fill: "#075255"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27.19,
    y: 35.11,
    width: 6.85,
    height: 9.55,
    fill: "#15a9af"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11.45,
    y: 35.11,
    width: 6.85,
    height: 9.55,
    fill: "#15a9af"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "5.26 52.23 5.26 52.57 5.26 55.06 58.74 55.06 58.74 52.23 5.26 52.23",
    fill: "#15a9af"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMill);
export default __webpack_public_path__ + "static/media/ic_mill.b59f836d6026bbc376dab2cd2f3f02e9.svg";
export { ForwardRef as ReactComponent };